<template>
  <navroot />
  <div class="scorll-box fadeIn">
    <div class="class-list-box">
      <div class="join-box">
        <span class="title-text">加入训练</span>
        <a-input-search size="large" class="join-input" v-model:value="keyword" placeholder="输入邀请码快速加入训练"
          @search="onSearch" />
      </div>
      <div class="list-box">
        <span class="title-text">全部训练</span>
        <a-spin class="list-spin" v-if="loading"></a-spin>
        <div class="class-list">
          <div class="class-item fadeIn" v-for="item in classList" @click="routeClass(item)">
            <i class="i-icon item-cover" :style="{ backgroundImage: 'url(' + item.CoverUrl + ')' }"></i>
            <div class="item-info">
              <div class="item-title">{{item.ClassName}}</div>
              <div class="item-time">创建：{{item.CreateTime}}</div>
            </div>
            <div class="item-bottom">
              <div class="item-int">
                <svg class="i-icon int-icon">
                  <use xlink:href="#icon-shuji" />
                </svg>
                <span>{{item.codeCount||0}}个环节</span>
              </div>
              <a-button size="small" class="enter-button" type="primary">进入</a-button>
            </div>
          </div>
          <a-empty v-if="!loading&&classList.length==0" description="未加入任何训练" />
        </div>
      </div>
      <!-- 加入训练 -->
      <div class="new-popupbox fadeIn" v-if="joinClass">
        <div class="hanlder-box">
          <svg class="i-icon popup-close" @click="joinClass = null">
            <use xlink:href="#icon-guanbi" />
          </svg>
        </div>
        <a-spin class="loading" v-if="loadJoinClass" />
        <div class="class-item fadeIn" v-if="joinClass">
          <i class="i-icon item-cover" :style="{ backgroundImage: 'url(' + joinClass.CoverUrl + ')' }"></i>
          <div class="item-info">
            <div class="item-title">{{joinClass.ClassName}}</div>
            <div class="item-time">创建：{{joinClass.CreateTime}}</div>
          </div>
          <div class="item-bottom">
            <div class="item-int">
              <svg class="i-icon int-icon">
                <use xlink:href="#icon-shuji" />
              </svg>
              <span>{{joinClass.codeCount||0}}个环节</span>
            </div>
            <a-button class="enter-button" @click="joining" :loading="isJoining">加入训练</a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navroot from "../nav/nav.vue";
import { LoadingOutlined } from '@ant-design/icons-vue';
import { PlatformGuid } from '@/config/wx';

export default {
  components: {
    navroot, LoadingOutlined
  },
  name: "login",
  data() {
    return {
      userGuid: '',
      loading: true,
      keyword: null,
      classList: [],

      loadJoinClass: false,
      joinClass: null,
      isJoining: false
    }
  },
  async mounted() {
    this.getClassList();
  },
  methods: {
    //获取某用户所有班级
    async getClassList() {
      this.loading = true;
      this.classList = [];
      let userInfo = this.$store.state.userInfo;
      this.userGuid = userInfo.PK_UserGuid;
      this.classList = await this.$api.classMessage.getClassOfUser({ userGuid: this.userGuid }).then(res => res.data || []);
      this.loading = false;
    },
    //跳转班级
    routeClass(item) {
      this.$router.push(`/list/${item.PK_ClassGuid}`);
    },
    //搜索
    async onSearch() {
      let keyword = this.keyword;
      if (keyword) this.keyword = keyword.trim();
      let res = await this.$api.classMessage.classCode({ code: this.keyword });
      if (!res.data) return this.$message.warning('邀请码不正确');
      let data = res.data;
      if (data.FK_PlatformGuid != PlatformGuid) return this.$message.warning('该班级不属于此平台，请确认班级绑定平台是否相符');
      let existClass = this.classList.find(item => item.PK_ClassGuid == data.PK_ClassGuid)
      if (existClass) return this.$message.warning('您已加入该班级，请勿重复加入');
      this.joinClass = data;
    },
    //加入班级中
    async joining() {
      if (this.isJoining) return;
      this.isJoining = true;
      let res = await this.$api.classMessage.joinClass({ userGuid: this.userGuid, code: this.keyword, platformGuid: PlatformGuid });
      this.isJoining = false;
      if (res.statusCode != 200) return this.$message.warning(res.message);
      this.joinClass = null;
      this.$message.success('加入训练成功');
      this.getClassList();
    }
  },
}
</script>

<style scoped lang="scss">
@import "./class-list.scss";
</style>